import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {TextField, IconButton, InputAdornment} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import Utils from './Utils';

const styles = theme => ({
  buttonSave: {
    width: '25px',
    height: '25px',
    display: 'inline',
  },
  invisible: {
    display: 'none',
  },
  visible: {
    display: 'inline',
  },
  textEdicao: {
    fontSize: 10,
    width: '80px',
  },
  textExibicao: {
    fontSize: 10,
    width: '60px',
  },
  textEdicaoMoney: {
    width: '120px',
  },
  textExibicaoMoney: {
    width: '100px',
  },
});

class EditableNumber extends React.Component {
  utils = new Utils();
  state= {
    alterou: false,
    valor: this.props.value === null ? '' : this.props.value,
    valorInicial: this.props.value === null ? '' : this.props.value,
    clickedOutside: false,
    modoEdicao: false
  }

  handleClickEditar = async event => {
    event.target.select();
    this.setState({modoEdicao: true, valor: this.props.value});
    await this.props.handleFocus();
  }
  handleChange = event => {
    var valorNovo = '';
    valorNovo = event.target.value !== '' ? this.utils.formataValor(event.target.value.substring(0, this.props.tamanho), event.target.defaultValue) : '';
    this.setState({ [event.target.name]: valorNovo, alterou: true });
  };
  handleSave = async (valor) => {
    await this.props.handleSave(valor, this.props.seqMensalidade, this.props.seqValor);
    this.setState({modoEdicao: false, alterou: false});
  };
  componentDidMount () {
    this.setState({valor: this.props.value, valorInicial: this.props.value});
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }
  myRef = React.createRef();

  handleClickOutside = e => {
    if (!this.myRef.current.contains(e.target)) {
      this.setState({ clickedOutside: true, modoEdicao: false, valor: this.state.valorInicial });
    }
  };

  handleClickInside = e => {
    this.setState({ clickedOutside: false, modoEdicao: true });
  }
  render () {
    const { classes } = this.props;
    return (
      <div className={classes.visible} id={this.props.index}>
        <div ref={this.myRef} onClick={this.handleClickInside} className={classes.visible}>
          <TextField
            className={this.state.modoEdicao ? (!this.props.isMoney ? classes.textEdicao : classes.textEdicaoMoney) : (!this.props.isMoney ? classes.textExibicao : classes.textExibicaoMoney)}
            id={this.props.index}
            onChange={this.handleChange}
            onFocus={this.handleClickEditar}
            value={this.state.valor === null ? '' : this.state.valor}
            InputProps={{
              inputProps: { min: 0 },
              startAdornment: !this.state.modoEdicao && this.props.isMoney && <InputAdornment position='start'>R$</InputAdornment>,
              endAdornment: <InputAdornment position='end' variant='filled'>
                <IconButton
                  color='primary'
                  className={this.state.modoEdicao && this.state.alterou ? classes.buttonSave : classes.invisible}
                  title='Salvar...'
                  onClick={() => this.handleSave(this.state.valor)}>
                  <CheckIcon className={classes.buttonSave} />
                </IconButton>
              </InputAdornment>,
              name: 'valor'
            }}
          />
        </div>
      </div>
    );
  }
}
export default withStyles(styles)(EditableNumber);
